export const calculatorsData = [
  {
    id: 1,
    calculatorName: "Personal Loan EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/personal-loan-emi-1738049877060.webp",
    link: "/calculators/emi-calculators/personal-loan-emi-calculator",
  },
  {
    id: 2,
    calculatorName: "Car Loan EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/car-loan-emi-1738049938014.webp",
    link: "/calculators/emi-calculators/car-loan-emi-calculator",
  },
  {
    id: 3,
    calculatorName: "Home Loan EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/home-loan-emi-1738049750722.webp",
    link: "/calculators/emi-calculators/home-loan-emi-calculator",
  },
  {
    id: 4,
    calculatorName: "Credit Card Loan EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/credit-card-loan-emi-1738050079311.webp",
    link: "/calculators/emi-calculators/credit-card-loan-emi-calculator",
  },
];
